import axios from 'axios'
// An expired token on a web route redirects to the home page instead of failing,
// which looks like success to axios: a tab open for hours must refresh it first.
const freshCsrfToken = () => axios.get('/sanctum/csrf-cookie')

const UserApi = {
    async getUser(id) {
       const user = await axios.get('/api/user')
       return user
    },
    async loginWithFirebase(token) {
        await freshCsrfToken()
        const { data } = await axios.post('/auth/firebase', {}, {
            headers: { Authorization: 'Bearer ' + token },
        })
        return data
    },
    async logoutUser() {
        await freshCsrfToken()
        await axios.post('/logout-user')
        localStorage.removeItem('_token')
    }
}

export default UserApi